import "./custom-select.scss";
import { Select } from "antd";

const { Option } = Select;

const CustomSelect = ({ options, placeholder, styles }) => {
  console.log(options);
  function onChange(value) {
    console.log(`selected ${value}`);
  }

  function onBlur() {
    console.log("blur");
  }

  function onFocus() {
    console.log("focus");
  }

  function onSearch(val) {
    console.log("search:", val);
  }
  return (
    <Select
      showSearch
      style={{ ...styles }}
      placeholder={placeholder}
      optionFilterProp="children"
      className="custom-select"
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onSearch={onSearch}
      filterOption={(input, option) =>
        option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {options.map((ele) => (
        <Option key={ele.value} value={ele.value}>{ele.title}</Option>
      ))}
    </Select>
  );
};

export default CustomSelect;
